import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 }
  };

  connect() {
    this.startTimer();
  }

  disconnect() {
    this.clearTimer();
  }

  dismiss() {
    this.clearTimer();
    this.fadeOut();
  }

  startTimer() {
    if (this.timeoutValue <= 0) return;
    this.timer = window.setTimeout(() => this.fadeOut(), this.timeoutValue);
  }

  clearTimer() {
    if (!this.timer) return;
    window.clearTimeout(this.timer);
    this.timer = null;
  }

  fadeOut() {
    if (this.isFading) return;
    this.isFading = true;
    this.element.classList.add("flash-toast--hiding");

    window.setTimeout(() => {
      this.element.remove();
      this.isFading = false;

      if (!this.element.parentElement?.hasChildNodes()) {
        this.element.parentElement?.remove();
      }
    }, 200);
  }
}
